import React from 'react'
import Breadcrumb from '../components/breadcrumb';

export default class IconsKeywords extends React.Component
{
    constructor(props)
    {
        super(props)    

        this.env = this.props.env;
        this.code = this.props.code;
        this.icons = this.props.icons.length > 0 ? this.props.icons : [];     
        this.codes = this.props.codes;

        // there are a few kpp that doesn´t have a all pages. that's weird. 
        // here we are just pointing the all icon to the same page. 
        this.all = {};
        this.all.u = "#";
        this.all.c = "demolition-contractors";

        this.dropTitle = 'All Demolition'

        this.icons.map(icon =>
        {
            if(icon.c === 'demolition-contractors') this.all = icon;  
            if(icon.c === 'residential-demolition') icon.c = 'deck';
            if(icon.c === 'oil-tank-removal') icon.c = 'tank-removal';

            let c = '';                                        

            switch(this.code)
            {
                case 'residential-demolition': c = 'deck'; break;
                case 'oil-tank-removal': c = 'tank-removal'; break;                               
                
                default:
                    c = this.code;
                    break;
            }

            const current = icon.c === c ? true : false;

            if(current)
            {
                let name = ''                                

                this.codes.map((code) =>
                {                                      
                    if(code.code === icon.c) name = code.name                  
                })
                
                switch(icon.c)
                {
                    case 'deck':
                        name = 'Deck, Shed or Fence'
                        break;

                    case 'tank-removal':
                        name = 'Tank Removal'
                        break;

                    case 'demolition-contractors':
                        name = 'All Demolition'
                        break;
                    
                    default:
                        name = name
                        break;
                } 

                this.dropTitle = name

            } 

            return true;
        })
        

        this.icons.sort((a,b) => (a.c > b.c) ? 1 : ((b.c > a.c) ? -1 : 0));  
    }

    gotoUrl = (url) =>
    {        
        if (typeof window !== "undefined") window.location.href = url;         
        return false
    }

    render()
    {        
        return(
            
            <div id='icons-keygroups-demolition-kpp' className="container-fluid icons-keygroups">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div class="dropdown icons mobile">
                                <a class="btn dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" data-target="dropdown-menu" aria-haspopup="true" aria-expanded="false" onClick={() => {document.getElementById('dropdownIcons').classList.toggle('show')}}>
                                    {this.dropTitle}
                                </a>

                                <div id='dropdownIcons' class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                    {
                                        this.icons.map((icon, index) =>
                                        {
                                            if(icon.c != 'demolition-contractors') return true

                                            return(<a className="dropdown-item" onClick={() => this.gotoUrl('/'+icon.u)} key={index} href={'/'+icon.u}>All Demolition</a>)
                                        })
                                    }
                                    {                                                                      
                                        this.icons.map((icon, index) =>
                                        {
                                            if(icon.c === 'demolition-contractors') return true;                                             
                                            
                                            let name = ''                                

                                            this.codes.map((code) =>
                                            {                                      
                                                if(code.code === icon.c) name = code.name                  
                                            })

                                            switch(icon.c)
                                            {
                                                case 'deck':
                                                    name = 'Deck, Shed or Fence'
                                                    break;

                                                case 'tank-removal':
                                                    name = 'Tank Removal'
                                                    break;
                                                
                                                default:
                                                    name = name
                                                    break;
                                            } 
                                            
                                            let c = '';                                        

                                            switch(this.code)
                                            {
                                                case 'residential-demolition': c = 'deck'; break;
                                                case 'oil-tank-removal': c = 'tank-removal'; break;                               
                                                
                                                default:
                                                    c = this.code;
                                                    break;
                                            }

                                            const current = icon.c === c ? true : false;

                                            return(<a className={"dropdown-item"+(current ?  ' current' : '')} onClick={() => this.gotoUrl('/'+icon.u)} key={index} href={'/'+icon.u}>{name}</a>)
                                        })
                                    }
                                </div>
                            </div>                             

                            <ul className="icons desktop">
                                <li className='li-icon'>
                                    <a href={'/'+this.all.u} className={'keyicon '+this.all.c+`${this.all.c === this.code ? ' current' : ''}`}>
                                        <div className="image"></div>   
                                    </a>
                                    <a href={'/'+this.all.u} className='icon-text'>All Demolition</a>
                                </li> 
                                {
                                    this.icons.map((icon, index) =>
                                    {                                 
                                        if(icon.c === 'demolition-contractors') return true; 
                                        
                                        let name = ''                                

                                        this.codes.map((code) =>
                                        {                                      
                                            if(code.code === icon.c) name = code.name                  
                                        })

                                        switch(icon.c)
                                        {
                                            case 'deck':
                                                name = 'Deck, Shed or Fence'
                                                break;

                                            case 'tank-removal':
                                                name = 'Tank Removal'
                                                break;
                                            
                                            case 'commercial-demolition':
                                                name = 'Commercial Building'
                                                break;

                                            case 'house-demolition':
                                                name = 'House or Garage'
                                                break;

                                            case 'mobile-home-demolition':
                                                name = 'Mobile Home'
                                                break;
                                            
                                            default:
                                                name = name
                                                break;
                                        } 

                                        let code = '';

                                        switch(this.code)
                                        {
                                            case 'residential-demolition': code = 'deck'; break;
                                            case 'oil-tank-removal': code = 'tank-removal'; break;                               
                                            
                                            default:
                                                code = this.code;
                                                break;
                                        }

                                        const current = icon.c === code ? ' current' : '';
                                        return(
                                            <li key={index} className='li-icon'>
                                                <a href={'/'+icon.u} className={'keyicon '+icon.c+current}>
                                                    <div className="image"></div>   
                                                </a>
                                                <a href={'/'+icon.u} className='icon-text'>{name}</a>
                                            </li>   
                                        )
                                    })
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            </div>        
        )
    }    
}